export const getIsoptimizelyDisabled = () => {
  const FORCE_DISABLE_OPTIMIZELEY_LOG_KEY = 'force-disable-optimizely-logs'
  return localStorage.getItem(FORCE_DISABLE_OPTIMIZELEY_LOG_KEY) === 'true'
}
